export const signatureDefaultSize = {
    width: 780,
    height: 280,
};
Object.freeze(signatureDefaultSize);
